import { createStoreModule } from '@/_core/fluxstore';
import { IAction } from '@/_core/fluxstore/types';
import { ProductsState } from './types';

const initState = () => {
    return new  ProductsState();
};

export const useProductsStore = createStoreModule<ProductsState, IAction<ProductsState>>(initState, 'root-Products');
